/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./InventoryView.css";
import ContentHeader from 'legacy/containers/ContentHeader';
import FormattedDate from 'legacy/components/FormattedDate'
import { getDateFormat } from 'legacy/constants'
import {
    fetchMe,
    fetchTeamInventoryReports,
    fetchInventory,
    fetchInventoryv2,
    fetchTeamInventoryReportUsage
} from 'legacy/containers/ApiUrls';
import {checkInventoryReportsFeatureEnabled, checkInventoryFeatureEnabled, checkLicenseManagementEnabled} from 'configs/index'
import EcgLoader from 'legacy/containers/EcgLoader';
import CustomSingleSelectComboBox from '../../components/Common/FormMUIWrapperComponents/CustomSingleSelectComboBox';
import { SELECT_FIELD_CONST } from '../../components/Common/FormMUIWrapperComponents/CustomSingleSelect/Constants'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'

import PageTab from 'legacy/components/PageTab'
import PageTabs from 'legacy/components/PageTabs'
// import CustomTableComponent from '../../components/Common/Table/CustomTableComponent'

import { Table } from 'antd';
import 'antd/dist/antd.css';
// import '../../components/Common/Table/CustomTableComponent/CustomTableComponent.css';
import TableHeader from '../../components/Common/Table/TableHeader';

const InventoryView = () => {
    const dispatch = useDispatch();
    const me = useSelector(state => state.app.dataSources.me);
    const isBackOfficeAdmin = me && me.data && me.data.profile.permissions.isBackOfficeAdmin
    const dateFormat = getDateFormat(me)
    const [CurrentPageTab, setCurrentPageTab] = useState("INVENTORY_VIEW") // INVENTORY_VIEW, HIERARCHY_VIEW
    const [PageLoaded, setPageLoaded] = useState(false)
    const [ReportContentLoaded, setReportContentLoaded] = useState(false)
    const [TableData, setTableData] = useState([])
    const [APIData, setAPIData] = useState([])
    
    const [Error, setError] = useState(false)


    useEffect( () => {
        if(!me.data && me.fetching == false){
            dispatch(fetchMe());
        }
    }, [])

    useEffect(async () => {
        if(me.data){
            const APIData = await dispatch(fetchInventoryv2(me.data.teams[0].id,me.data.teams[0].id));
            setAPIData(APIData)
            setPageLoaded(true)
        }
    }, [me])
    
    useEffect(async () => {
        if(PageLoaded){
            // Page Loaded 
            const { data, practiceInfo } = APIData;
            let practiceMap = {}
            if(data && practiceInfo) { try {
                practiceInfo.forEach((item) => {
                    practiceMap[item.practiceId] = item.practiceName
                })
                const TableData = data && data.map((item) => {
                    const { licenseOrder, usageInfo } = item;
                    const { practiceId, licensePurchased, available, masterLicenseName, orders } = licenseOrder;
                    const pending = usageInfo && usageInfo.reduce((acc, item) => {
                        return acc + parseInt(item.pending)
                    }, 0)
                    const redeemed = usageInfo && usageInfo.reduce((acc, item) => {
                        return acc + parseInt(item.redeemed)
                    }, 0)

                    const activeOrder = orders.find((item) => {
                        return item.isActive == true && item.parentOrderId == null
                    })
                    let tableData =  {
                        "connectionInventoryID": practiceId,
                        "parentTeamID": practiceId,
                        "parentTeamName": practiceId,
                        "teamID": practiceId,
                        "teamName": practiceMap[practiceId] || practiceId,
                        "key"  : practiceId,
                        "orderID": activeOrder.purchaseOrderNumber,
                        "connectionTemplateID": "null",
                        "connectionTemplateName": masterLicenseName,
                        "allocatedConnectionsCount": licensePurchased,
                        "available": available,
                        "generatedCodeCount": parseInt(pending) + parseInt(redeemed),
                        "redeemedCodeCount": redeemed,
                        "expiresAt": activeOrder.expiryDate,
                        "createdAt": activeOrder.goLiveDate
                    }
                    if (CurrentPageTab == "INVENTORY_VIEW") {
                        // do nothing
                    }
                    if (CurrentPageTab == "HIERARCHY_VIEW") {
                        const childData =  usageInfo && usageInfo.map((item) => {
                            let cdata = {
                                ...tableData,
                                "teamID": item.practiceId,
                                "teamName": practiceMap[item.practiceId] || item.practiceId,
                                "key"  : item.practiceId,
                                "generatedCodeCount": parseInt(item.pending) + parseInt(item.redeemed),
                                "redeemedCodeCount": item.redeemed,
                            }
                            return cdata;
                        })
                        tableData.children = childData;
                    }
                    return tableData;
                })
                setTableData(TableData)
                setReportContentLoaded(true)
            } catch (err) { console.log(err); setError(true); setReportContentLoaded(true);} }else {
                setTableData([])
                setReportContentLoaded(true)
            }
        }
    }, [PageLoaded, CurrentPageTab])

    // Table Row Object :
    // {
    //     "connectionInventoryID": "a9azrR8qdiwaoXmVaJUqcl8r5wibcnxe",
    //     "parentTeamID": "vtq22bdnpDCN9Vc3F620cl8qzs0xvnkg",
    //     "parentTeamName": "GE MUSE - Staging",
    //     "teamID": "vtq22bdnpDCN9Vc3F620cl8qzs0xvnkg",
    //     "teamName": "GE MUSE - Staging",
    //     "orderID": null,
    //     "connectionTemplateID": "ARJrvJ0UY3AUUyz8HGN9cl8r2pgqdklg",
    //     "connectionTemplateName": "30-Day License",
    //     "allocatedConnectionsCount": 96,
    //     "generatedCodeCount": 2,
    //     "redeemedCodeCount": 6,
    //     "expiresAt": "2022-08-05T17:34:45.554688Z",
    //     "createdAt": "2022-07-06T17:34:45.554693Z"
    // }

    const InventoryViewTableColumns = [
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="&nbsp;"
                    keyMap="createdAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            width: 5,
            render: (text, record, index) => {
                const data = record.createdAt && `${record.createdAt}`;
                return (
                <p>

                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Practice"
                    keyMap="teamName"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'teamName',
            width: 200,
            key: 'teamName',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                const data = record.teamName && `${record.teamName}`;
                if (!record.parentTeamID) {
                    return (
                        <b>
                            {data}
                        </b>
                    );
                } else {
                    return (
                        <p>
                            {data}
                        </p>
                    );
                }
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Short Description"
                    keyMap="connectionTemplateName"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'connectionTemplateName',
            width: 200,
            key: 'connectionTemplateName',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.connectionTemplateName && `${record.connectionTemplateName}`;
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Order Id"
                    keyMap="orderID"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'orderID',
            key: 'orderID',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.orderID ? `${record.orderID}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Go Live Date"
                    keyMap="createdAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'createdAt',
            width: 110,
            key: 'createdAt',
            render: (text, record, index) => {
                const data = record.createdAt && `${record.createdAt}`;
                return (
                <p>
                    <FormattedDate date={data} fmt={dateFormat} overrideSameDay={true} overrideLastDay={true} me={me}/>
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Expiry Date"
                    keyMap="expiresAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'expiresAt',
            width: 110,
            key: 'expiresAt',
            render: (text, record, index) => {
                const data = record.expiresAt && `${record.expiresAt}`;
                return (
                <p>
                    <FormattedDate date={data} fmt={dateFormat} overrideSameDay={true} overrideLastDay={true} me={me}/>
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Expiry Days"
                    keyMap="expiresAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'DaysUntilExpiration',
            width: 110,
            key: 'expiresAt',
            render: (text, record, index) => {
                const data = record.expiresAt && `${record.expiresAt}`;
                const today = new Date();
                const expirationDate = new Date(data);
                const timeDiff = Math.abs(expirationDate.getTime() - today.getTime());
                let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
                if (diffDays == 1) {
                    diffDays = "Tomorrow";
                }
                if (diffDays == 0) {
                    diffDays = "Today";
                }
                if (diffDays < 0) {
                    diffDays = "Expired";
                }
                if (diffDays > 1) {
                    diffDays = `In ${diffDays} days`;
                }
                return (
                <p>
                    {diffDays}
                </p>
                );
            }
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Purchased"
                    keyMap="allocatedConnectionsCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'allocatedConnectionsCount',
            key: 'allocatedConnectionsCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.allocatedConnectionsCount && `${record.allocatedConnectionsCount}`;
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Available"
                    keyMap="allocatedConnectionsCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'allocatedConnectionsCount',
            key: 'allocatedConnectionsCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                let available = record.available ? record.available : (record.allocatedConnectionsCount && record.allocatedConnectionsCount - record.generatedCodeCount);
                const data = available ? `${available}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Pending"
                    keyMap="generatedCodeCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                />
                );
            },
            dataIndex: 'generatedCodeCount',
            key: 'generatedCodeCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const pending = record.generatedCodeCount && record.generatedCodeCount - record.redeemedCodeCount;
                const data = pending ? `${pending}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Redeemed"
                    keyMap="redeemedCodeCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'redeemedCodeCount',
            key: 'redeemedCodeCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.redeemedCodeCount ? `${record.redeemedCodeCount}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
    ]


    if (PageLoaded && !(checkInventoryReportsFeatureEnabled(me).enabled || checkLicenseManagementEnabled(me).enabled) || !isBackOfficeAdmin) {
        return (
          <div data-page="add-new-patienth" className={styles.addNewPatient}>
            <AccessDeniedContent
              title="Inventory"
            />
          </div>
        )
      }
  
    
    return (
        <React.Fragment>
            <div data-page="Inventory" className={styles.InventoryViewPage}>
                <ContentHeader
                    isLoading={me.isFetching}
                    showLastRefresh={false}
                    text="Inventory"
                    me={me}
                    showAddPatient={false}
                    enableBackButton={false}
                    isFullWidth={true}
                />
                <div className={styles.container}>
                    { (!PageLoaded || !ReportContentLoaded) ? <div className={styles.loaderPage}><EcgLoader /></div> : 
                    (!Error ? (<div className={styles.page}>
                        <React.Fragment>
                            <PageTabs>
                                <PageTab
                                dataAction="inventory"
                                isActive={CurrentPageTab === "INVENTORY_VIEW"}
                                handleOnClick={() => setCurrentPageTab("INVENTORY_VIEW")}
                                getLabel={() => 'Inventory View'}
                                />
                                {checkInventoryReportsFeatureEnabled(me).enabled && <PageTab
                                dataAction="hierarchy"
                                isActive={CurrentPageTab === "HIERARCHY_VIEW"}
                                handleOnClick={() => setCurrentPageTab("HIERARCHY_VIEW")}
                                getLabel={() => 'Hierarchy View'}
                                />}
                            </PageTabs>
                        </React.Fragment>
                        {CurrentPageTab === "INVENTORY_VIEW" &&
                            <React.Fragment>
                                <h1 className={styles.sectionTitle}>Inventory</h1>
                                <span className={styles.sectionCaption}>Showing inventory of {TableData.length} practice(s)</span>
                                {TableData.length > 0 ?(
                                <React.Fragment>
                                    {/* Data Table */}
                                    <Table
                                        styles={{marginTop:'30px'}}
                                        key="invTable"
                                        columns={InventoryViewTableColumns}
                                        dataSource={TableData}
                                        pagination={false}
                                    />
                                </React.Fragment> ) : (
                                    <React.Fragment>
                                        <h1 className={`${styles.title} ${styles.loaderPage}`}> 
                                            {checkInventoryReportsFeatureEnabled(me).enabled ? 'No Inventory Reports Found' : 'No Inventory Found'}
                                            <br/> <small>Contact Administrator</small> 
                                        </h1>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        }
                        {CurrentPageTab === "HIERARCHY_VIEW" &&
                            <React.Fragment>
                                <h1 className={styles.sectionTitle}>Practice Hierarchy</h1>
                                <span className={styles.sectionCaption}>Select Practice to view inventory usage</span>
                                {TableData.length > 0 ?(
                                <React.Fragment>
                                    {/* Data Table */}
                                    <Table
                                        styles={{marginTop:'30px'}}
                                        key="invTable"
                                        columns={InventoryViewTableColumns}
                                        dataSource={TableData}
                                        pagination={false}
                                    />
                                </React.Fragment> ) : (
                                    <React.Fragment>
                                        <h1 className={`${styles.title} ${styles.loaderPage}`}> 
                                            {checkInventoryReportsFeatureEnabled(me).enabled ? 'No Inventory Reports Found' : 'No Inventory Found'}
                                            <br/> <small>Contact Administrator</small> 
                                        </h1>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        }
                    </div>) : (<div className={styles.loaderPage}><h1>Error Fetching Inventory</h1></div>))
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

export default InventoryView


// WEBPACK FOOTER //
// ./src/views/pages/InventoryView/InventoryView.jsx